import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VoyageService {
  public baseurl = environment.apiUrl;
  private voyageApi = "api/Voyage/";
  constructor(private http: HttpClient) { }

  getVoyagePerformance(data) {
    const url = this.baseurl + this.voyageApi + 'GetVoyagePerformance';
    return this.http.post(url, data).pipe();
  }
  getMasterLookUpMonth() {
    const url = this.baseurl + this.voyageApi + 'GetMasterLookUpMonth';
    return this.http.get(url).pipe();
  }
  getVoyagePerformanceByShippingLine(data) {
    const url = this.baseurl + this.voyageApi + 'GetVoyagePerformanceByShippingLine';
    return this.http.post(url, data).pipe();
  }
  getVoyagePerformanceForDayChart(data) {
    const url = this.baseurl + this.voyageApi + 'GetVoyagePerformanceForDayChart';
    return this.http.post(url, data).pipe();
  }

  getRegionData() {
    const url = this.baseurl + this.voyageApi + 'GetMasterRegion';
    return this.http.get(url).pipe();
  }
  getVoyagePerformanceByRegion(data) {
    const url = this.baseurl + this.voyageApi + 'GetVoyagePerformanceByRegion';
    return this.http.post(url, data).pipe();
  }

  getVoyageByShippinglineIdAndVesselId(shippinglineId:number,vesselId:number,fromDate:string){
    const url = this.baseurl + this.voyageApi + 'ports?shippinglineId='+shippinglineId+"&vesselId="+vesselId+"&fromDate="+fromDate;
    return this.http.get(url);
  }

}
